export enum iconColors {
  white = 'white',
  black = 'black',
  darkGrey = 'darkGrey',
  grey = 'grey',
  primary = 'primary',
  red = 'red',
  orange = 'orange',
  mustard = 'mustard',
  butterflyBlue = 'butterflyBlue',
  green = 'green',
  lightGreen = 'lightGreen',
}

export enum iconSizes {
  lg = 'lg',
  xl = 'xl',
  sm = 'sm',
  md = 'md',
  xs = 'xs',
  sml = 'sml',
}
